module.exports = __webpack_public_path__ + "static/media/29_plantilla_cuadrada_combo_duo_cp_aguas_pet_591_swsg.d0edb824.png";